import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import DataTable from '../../components/common/DataTable';
import { createResourceService } from '../../services/api.service';

const assignmentsService = createResourceService('employee-portal/assignments');

const MyAssignments = () => {

    const tableColumns = useMemo(() => [
        { 
            key: 'project_name', 
            label: 'Project/Client', 
            type: 1, 
            sortable: true, 
            render: (item) => (
                <div style={{ fontWeight: '600' }}>
                    <Link to={`/employee/assignments/${item.id}`} style={{ color: 'var(--primary)', textDecoration: 'none' }}>
                        {item.project_name || 'N/A'}
                    </Link>
                </div>
            ) 
        },
        { key: 'role', label: 'Role', type: 1, sortable: true },
        { key: 'start_date', label: 'Start Date', type: 1, sortable: true, render: (item) => item.start_date ? new Date(item.start_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : '' },
        { key: 'end_date', label: 'End Date', type: 1, sortable: true, render: (item) => item.end_date ? new Date(item.end_date).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : '-' },
        { key: 'status', label: 'Status', type: 1, sortable: true, render: (item) => {
            let badgeClass = '';
            if (item.status === 'Active') badgeClass = 'success';
            else if (item.status === 'Ended') badgeClass = 'light';
            else badgeClass = 'danger'; // Inactive
            return <span className={`td-badge ${badgeClass}`}>{item.status}</span>;
        } }
    ], []);

    const config = {
        title: (
            <span>
                <h2>My Assignments</h2>
                <p>View your active client assignments and project schedules.</p>
            </span>
        ),
        searchables: ['project_name', 'role', 'status'],
        add: false,
        edit: false,
        delete: false,
        archive: false,
    };

    return (
        <DataTable
            resourceName="employee-portal/assignments"
            apiService={assignmentsService}
            columns={tableColumns}
            config={config}
        />
    );
};

export default MyAssignments;
